import { extractPaymentAttachmentValues, isPaymentAttachmentField } from '../helpers/paymentAttachmentCodes'
import { normalizeAttachmentList } from '../helpers/paymentAttachments'
import { formatMoney } from '../helpers/utils'

const CHARGE_SUMMARY_FIELD_CODES = new Set(['summary_ref'])

export function buildChargeSummaryFields(activity = {}) {
  return [
    {
      label: 'Número de cobro',
      value: activity.charge_db_ref || '-'
    }
  ]
}

export function buildChargeExtraFields(customFields = []) {
  if (!Array.isArray(customFields) || !customFields.length) return []

  return customFields.reduce((acc, field) => {
    if (!field || isPaymentAttachmentField(field)) return acc
    if (CHARGE_SUMMARY_FIELD_CODES.has(field?.code)) return acc

    acc.push({
      label: field?.label || '-',
      value: field?.value || '-'
    })

    return acc
  }, [])
}

export function parsePaymentMethodCustomFields(customFieldsItem) {
  if (!customFieldsItem) return []

  if (Array.isArray(customFieldsItem)) {
    return customFieldsItem
  }

  if (typeof customFieldsItem === 'string' && customFieldsItem.trim() !== '') {
    try {
      const parsedFields = JSON.parse(customFieldsItem)
      return Array.isArray(parsedFields) ? parsedFields : []
    } catch (error) {
      console.error('Error al parsear custom_fields_item del pago:', error, customFieldsItem)
    }
  }

  return []
}

export function buildChargePaymentAttachmentCounters(paymentMethods = []) {
  if (!Array.isArray(paymentMethods)) return []

  return paymentMethods.map((paymentMethod) => {
    const parsedCustomFields = parsePaymentMethodCustomFields(paymentMethod?.custom_fields_item)
    const attachments = extractPaymentAttachmentValues(parsedCustomFields)
    const normalizedImages = normalizeAttachmentList(attachments.images)
    const normalizedFiles = normalizeAttachmentList(attachments.files)

    return {
      imagesCount: normalizedImages.length,
      filesCount: normalizedFiles.length,
      imageUrls: normalizedImages.map((image) => image.url),
      fileUrls: normalizedFiles.map((file) => file.url)
    }
  })
}

export function buildChargeTotalRows(activity = {}) {
  return [
    {
      label: 'TOTAL PAGADO POR EL CLIENTE:',
      value: formatMoney(activity?.payment_methods?.reduce((total, paymentMethod) => {
        return total + Number(paymentMethod?.amount || 0)
      }, 0) || 0),
      strong: true
    },
    {
      label: 'TOTAL DOCUMENTOS APLICADOS:',
      value: formatMoney(activity?.total_amount || 0),
      strong: true
    }
  ]
}
